module.exports = __webpack_public_path__ + "img/Check.a872f708.svg";